export interface SelectOption {
  value: string | number;
  label: string;
}

export interface ListingGroup<T> {
  id: number;
  name: string;
  expanded: boolean;
  items: T[];
}

// Category ids start at 1, so 0 never matches a real category
export const UngroupedGroupId = 0;

export enum GroupedListPopup {
  Group = 'groupedListGroupPopup',
}
